"use client";
import { cn } from "utils";
import { formatAskUserQuestionAnswerDisplay } from "./parseAskUserQuestionResult";
import { InteractiveToolResultCards } from "./InteractiveToolResultCard";
import type { AskUserQuestionAnswer, AskUserQuestionToolInfo } from "./types";

export interface AskUserQuestionResultCardsProps {
  /** parseAskUserQuestionResult 的完整输出；length > 1 时纵向多张卡 */
  answers: AskUserQuestionAnswer[];
  toolInfo?: AskUserQuestionToolInfo;
  className?: string;
}

/**
 * 多题查看态容器：对 result 数组 map 渲染多张 AskUserQuestionResultCard。
 */
export const AskUserQuestionResultCards: React.FC<
  AskUserQuestionResultCardsProps
> = ({ answers, toolInfo, className }) => {
  const items = answers
    .map((answer) => ({
      key: `${answer.questionIndex}-${answer.question}`,
      title: answer.question,
      body: formatAskUserQuestionAnswerDisplay(answer),
    }))
    .filter((item) => item.body.trim().length > 0);

  return (
    <InteractiveToolResultCards
      items={items}
      toolInfo={toolInfo}
      className={cn(className)}
    />
  );
};
